import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { get } from 'lodash';
import { EINREICHUNG_DER_UNTERLAGEN } from 'src/lib/constants/constant';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

/**
 * ***********************************************************************
 * ******** Informationen zum Upload der Beihilferelevanz-Erklärung ******
 * ***********************************************************************
 */
export const BeihilferelevanzVordemUploadInformation: FC<{ application: any }> = ({ application }) => {
	const EinreichungDerUnterlagen = get(
		application,
		P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path,
		'',
	);

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.digital) {
		return (
			<>
				<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
					Upload der Beihilferelevanz-Erklärung
				</Typography>
				<Typography>Bitte laden Sie hier die unterzeichnete Beihilferelevanz-Selbsterklärung als pdf-Datei hoch:</Typography>
			</>
		);
	}
	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		return (
			<>
				<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
					Upload der Beihilferelevanz-Erklärung
				</Typography>
				<Typography>
					Bitte laden Sie hier die unterzeichnete Beihilferelevanz-Selbsterklärung (pdf-Datei) als Vorab-Information über das Upload-Feld
					hoch:
				</Typography>
			</>
		);
	}

	return <></>;
};

/**
 * ***********************************************************************
 * ******** Informationen nach dem Download ******************************
 * ***********************************************************************
 */
export const BeihilferelevanzNachdemDownloadInformation: FC<{ application: any }> = ({ application }) => {
	const EinreichungDerUnterlagen = get(
		application,
		P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path,
		'',
	);

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.digital) {
		return (
			<Typography>
				Bitte unterzeichnen Sie die Erklärung und laden Sie sie im nächsten Schritt als pdf-Datei hoch.
			</Typography>
		);
	}
	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		return (
			<Typography>
				Bitte unterzeichnen Sie die Erklärung eigenhändig und laden Sie eine Kopie als pdf-Datei im nächsten Schritt hoch. Das
				unterschriebene Original reichen Sie bitte postalisch ein.
			</Typography>
		);
	}

	return <></>;
};

/**
 * ***********************************************************************
 * ******** Hier sind die Informationen zum Postversand ******************
 * ***********************************************************************
 */
const BeihilferelevanzPostVersandInfo: FC<{ application: any }> = ({ application }) => {
	const EinreichungDerUnterlagen = get(
		application,
		P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path,
		'',
	);

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		return (
			<Box sx={{ mt: '2rem' }}>
				<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
					Postversand der Beihilferelevanz-Erklärung
				</Typography>
				<Typography>
					Bitte senden Sie die unterschriebene Beihilferelevanz-Selbsterklärung im Original an die im Förderprogramm angegebene
					Postadresse.
				</Typography>
			</Box>
		);
	}

	return <></>;
};

export default BeihilferelevanzPostVersandInfo;
